// Every stage gets its real values from build-time env vars: the dev/prod
// pipelines inject VITE_COGNITO_* and VITE_API_BASE_URL from CDK stack outputs.
// The fallbacks below are deliberately NON-real placeholders (not any dev/prod
// resource) so a misconfigured build fails loudly instead of silently pointing
// at the wrong environment. They only ever apply to local `web:local`, where
// Cognito auth is bypassed (localMock) and the values are unused.
export const config = {
  region: import.meta.env.VITE_AWS_REGION || "ap-northeast-2",
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || "ap-northeast-2_000000000",
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || "0000000000000000000000000",
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, ""),
  // Fully-offline local test mode (`pnpm web:local`): bypasses Cognito auth as
  // a mock Admin and processes uploads in the browser. NEVER set in dev/prod.
  localMock: import.meta.env.VITE_LOCAL_MOCK === "true"
};
